module.exports = __webpack_public_path__ + "static/media/ceremony_jess.fdb86add.jpg";